import Button from "@mui/material/Button";
import FormGroup from "@mui/material/FormGroup";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { get, post } from "../../../../utils/api";
import SnackbarAlert from "../../../common/sanckbar";
import Autocomplete from "@mui/material/Autocomplete";

function NewBrand() {
  const navigate = useNavigate();
  const [snackbar, setSnackbar] = useState(false);
  const [alert_severity, setAlertSeverity] = useState("warning");
  const [alert_message, setMessage] = useState("");

  const [formData, setFormData] = useState({
    brand_id: 0,
    brand_name: "",
    image_id: "",
    image_url: "",
    del: 0,
    status_id: 1,
    status: "active",
  });

  const handleNewBrand = async (e: any) => {
    e.preventDefault();

    let brandDetails = {
      brand_id: formData.brand_id,
      brand_name: formData.brand_name,
      image_id: formData.image_id,
      image_url: formData.image_url,
      del: formData.del,
      status_id: formData.status_id,
      status: formData.status,
    };

    try {
      const response = await post("brands", brandDetails);

      if (response) {
        alert("Brand added successfully", "success");
        navigate("/brands/list");
      }
    } catch (error) {
      console.log(error);
      alert("Something went wrong", "warning");
    }
  };

  const handleChange = (e: any) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const alert = (message: string, alert_severity: string) => {
    setSnackbar(true);
    setMessage(message);
    setAlertSeverity(alert_severity);
  };

  const closeSnackbar = () => {
    // this.setState({ snackbar: false });
    setSnackbar(false);
  };

  return (
    <>
      <SnackbarAlert
        open={snackbar}
        closeSnackbar={closeSnackbar}
        message={alert_message}
        severity={alert_severity}
      />

      <div
        className="container"
        style={{ marginTop: "22px", paddingLeft: "20px" }}
      >
        <div className="row new-client-header">
          <div className="col-xs-12">
            <h5>New Brand</h5>
          </div>
        </div>
        <form onSubmit={handleNewBrand} style={{ maxWidth: "1152px" }}>
          <div className="row mt-3 mb-3">
            <div className="col-xs-12 col-md-4 col-lg-4 d-flex align-items-center">
              <label htmlFor="brandName">Brand Name</label>
            </div>
            <div className="col-xs-12 col-md-8 col-lg-8">
              <FormGroup>
                <TextField
                  sx={{ width: "100% !important" }}
                  fullWidth
                  required
                  id="brandName"
                  className="reg-input name-field"
                  name="brand_name"
                  value={formData.brand_name}
                  onChange={handleChange}
                  // error={Boolean(errorState.first_name)}
                  // helperText={errorState.first_name}
                  placeholder="Brand Name"
                />
              </FormGroup>
            </div>
          </div>

          <div className="d-flex justify-content-end">
            <Button
              variant="contained"
              type="submit"
              className="d-flex justify-content-end"
              style={{ marginBottom: "50px" }}
            >
              <span>Save</span>
            </Button>
          </div>
        </form>
      </div>
    </>
  );
}

export default NewBrand;
